import { TestOrganization } from './types';

// Risk Manager organization
export const riskManagerOrganization: TestOrganization = {
  highbondId: '675',
  name: 'rm-po-toolkit-test',
  urlPrefix: 'rm-po-toolkit-test',
  id: '675f833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'rm-po-toolkit-test',
};

export const devRiskManagerTestOrganizations: TestOrganization[] = [
  riskManagerOrganization,
];
